import { Fragment, useCallback, useEffect } from "react";
import Table from "components/Table/Table";
import { UNAUTHORIZED } from "constants";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "components/Pagination/Pagination";
import { toast } from "react-hot-toast";
import { setNavbarTitle } from "features/navbar/navbarSlice";
import TableSkeleton from "components/Table/TableSkeleton/TableSkeleton";
import { selectAuthUser } from "features/auth/authSlice";
import { actions } from "utils/helpers";
import {
  useGetUsersQuery,
  useDeleteUserMutation,
} from "features/user/userApiSlice";

import cardStyles from "styles/modules/Card.module.scss";

const Users = ({ label }) => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const {
    currentData,
    isFetching: isLoading,
    isError,
    error
  } = useGetUsersQuery(searchParams.toString());

  const dispatch = useDispatch();

  const authUser = useSelector(selectAuthUser);

  const [deleteUser] = useDeleteUserMutation();

  useEffect(() => {
    dispatch(setNavbarTitle("Users"));
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      toast.error(error || "Could not load users, try refreshing the page");
    }
  }, [isError, error]);

  const onItemClickHandler = (id) => {
    navigate(`/users/${id}`);
  };

  // const onEditBtnHandler = useCallback(
  //   (id, callFn = false) => {
  //     if (authUser?.actions[label].includes(actions.view)) {
  //       if (callFn) {
  //         navigate(`/users/${id}`);
  //       }

  //       return "";
  //     }

  //     return UNAUTHORIZED;
  //   },
  //   [authUser?.actions, label, navigate]
  // );

  const onDeleteBtnHandler = useCallback(
    async (id, callFn = false) => {
      if (authUser?.actions[label].includes(actions.delete)) {
        if (callFn) {
          await deleteUser(id).unwrap();
        }

        return "";
      }

      return UNAUTHORIZED;
    },
    [authUser?.actions, deleteUser, label]
  );

  return (
    <div>
      <div className={cardStyles.menu}>
        <h3>Showing data for users</h3>
      </div>
      {isLoading ? (
        <TableSkeleton />
      ) : (
        <Fragment>
          <Table
            data={currentData}
            onItemClickHandler={onItemClickHandler}
            // onEdit={onEditBtnHandler}
            onDelete={onDeleteBtnHandler}
          />
          <Pagination totalCount={currentData?.size} />
        </Fragment>
      )}
    </div>
  );
};

export default Users;
